import type { CollectDocumentConfig, CollectDocumentConfigCustom } from '@onefootprint/request-types';
import { DOC_REQUEST_KIND } from '@/idv2/features/collect-document/types';

const getCustomDocInfo = (config: CollectDocumentConfig) => {
  const documentRequestKind = config.kind;
  let documentName: string | undefined;
  let documentDescription: string | undefined;
  if (documentRequestKind === DOC_REQUEST_KIND.custom) {
    documentName = (config as CollectDocumentConfigCustom).name;
    documentDescription = (config as CollectDocumentConfigCustom).description;
  }

  return {
    documentName,
    documentDescription,
  };
};

export default getCustomDocInfo;
